import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import formCadastroEvento from "../schemas/forms";
import { ChangeEvent, useState } from "react";

// Material ui Icon
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {
  DeleteOutlineTwoTone,
  PictureAsPdfOutlined,
} from "@mui/icons-material";
import MDEditor from "components/MDEditor";
import MDButton from "components/MDButton";
import { deleteDocumentoEvento } from "services/evento";
import { getFileNameFromUrl } from "helpers/utils";
import { setMessage, useMaterialUIController } from "context";

const { formField } = formCadastroEvento;
const { termoResp } = formField;

interface FieldDetailsProps {
  eventoId?: number;
  fileTermoResp: File | null;
  values: {
    [x: string]: string;
  };
  handlerFileTerm: (event: ChangeEvent<HTMLInputElement>) => void;
  handlerDeleteFileTerm: () => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export default function FieldTermoResp({
  values,
  eventoId,
  handlerDeleteFileTerm,
  fileTermoResp,
  handlerFileTerm,
  setFieldValue,
}: FieldDetailsProps) {
  const [, dispatch] = useMaterialUIController();

  const handlerExcluirArquivo = async () => {
    try {
      if (!eventoId || !values.urlTermoResp) return;
      const response = await deleteDocumentoEvento(
        Number(eventoId),
        "urlTermoResp",
        getFileNameFromUrl(values.urlTermoResp)
      );
      if (response.status === 200) {
        handlerDeleteFileTerm();
        setFieldValue("urlTermoResp", "");
      }
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        text: error.message,
        severity: "error",
      });
    }
  };

  const DeleteTermo = () => {
    const [confirmed, setConfirmed] = useState(false);

    return !confirmed ? (
      <IconButton component="label" onClick={() => setConfirmed(true)}>
        <DeleteOutlineTwoTone color="error" />
      </IconButton>
    ) : (
      <MDBox>
        <Typography variant="caption">Tem certeza?</Typography>
        <MDBox display="flex" gap={1}>
          <MDButton
            variant="outlined"
            color="success"
            size="small"
            onClick={handlerExcluirArquivo}
          >
            Sim
          </MDButton>
          <MDButton
            variant="outlined"
            color="error"
            size="small"
            onClick={() => setConfirmed(false)}
          >
            Não
          </MDButton>
        </MDBox>
      </MDBox>
    );
  };

  return (
    <Card
      id="termo-responsabilidade"
      sx={{ overflow: "visible", margin: "10px 0" }}
    >
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Termo de Responsabilidade</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Insira um arquivo PDF ou digite o termo de responsabilidade no campo
          abaixo.
        </MDTypography>
      </MDBox>

      <MDBox pb={3} px={3}>
        <MDBox
          borderRadius="lg"
          display="flex"
          justifyContent={fileTermoResp ? "space-between" : "flex-start"}
          alignItems="center"
          p={1}
          sx={{
            backgroundColor: ({ palette: { light } }) => light.main,
            position: "relative",
            height: "auto",
            minHeight: "40px",
            border: ({ borders: { borderWidth, borderColor } }) =>
              `${borderWidth[1]} dashed ${borderColor}`,
          }}
        >
          {fileTermoResp ? (
            <>
              <MDBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfOutlined fontSize="small" />
                <Typography variant="caption">{fileTermoResp.name}</Typography>
              </MDBox>
              <Typography variant="caption">
                {fileTermoResp.size} byte
              </Typography>
              <IconButton component="label" onClick={handlerDeleteFileTerm}>
                <DeleteOutlineTwoTone color="error" />
              </IconButton>
            </>
          ) : values.urlTermoResp ? (
            <MDBox
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <MDTypography
                component="a"
                href={values.urlTermoResp}
                target="_blank"
                rel="noreferrer"
                variant="h6"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <PictureAsPdfOutlined fontSize="small" />
                {getFileNameFromUrl(values.urlTermoResp)}
              </MDTypography>
              <DeleteTermo />
            </MDBox>
          ) : (
            <IconButton component="label" sx={{ padding: "10px", gap: 1 }}>
              <input
                name="urlTermoResp"
                hidden
                accept="application/pdf"
                type="file"
                onChange={handlerFileTerm}
              />
              <PictureAsPdfOutlined fontSize="large" />
              <Typography variant="caption">Selecionar arquivo</Typography>
            </IconButton>
          )}
        </MDBox>
      </MDBox>

      {!fileTermoResp && (
        <MDBox pb={3} px={3}>
          <MDEditor
            name={termoResp.name}
            value={values.termoResp}
            onChange={setFieldValue}
            placeholder="Digite o termo de responsabilidade..."
          />
        </MDBox>
      )}
    </Card>
  );
}
